import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Router } from '@angular/router';
import {
  fetchCommissionGroup,
  fetchCommissionGroupSuccess,
  fetchCommissionGroupFailure,
  getCommissionGroup,
  getCommissionGroupSuccess,
  getCommissionGroupFailure,
  deleteCommissionGroup,
  deleteCommissionGroupSuccess,
  deleteCommissionGroupFailure,
  addCommissionGroup,
  addCommissionGroupSuccess,
  addCommissionGroupFailure,
  updateCommissionGroup,
  updateCommissionGroupSuccess,
  updateCommissionGroupFailure,
  fetchCommissionGroupsByAffiliate,
  fetchCommissionGroupsByAffiliateSuccess,
  fetchCommissionGroupsByAffiliateFailure
} from './commission-groups.actions';
import { of } from 'rxjs';
import { map, mergeMap, catchError, tap } from 'rxjs/operators';
import { CommissionGroupService } from '@services/commission-groups/commission-group.service';

@Injectable()
export class CommissionGroupEffects {
  loadCommissionGroup$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fetchCommissionGroup),
      mergeMap((action) =>
        this.commissionGroupService.getCommissionGroups(action.page, action.campaignID, action.filterOptions).pipe(
          map(res => {
            return fetchCommissionGroupSuccess({ commissionGroup: res });
          }),
          catchError(error => {
            return of(fetchCommissionGroupFailure({ error }));
          })
        )
      )
    )
  );

  loadCommissionGroupsByAffiliate$ = createEffect(() =>
  this.actions$.pipe(
    ofType(fetchCommissionGroupsByAffiliate),
    mergeMap((action) =>
      this.commissionGroupService.getCommissionGroupsByAffiliate(action.page, action.affiliateID, action.filterOptions).pipe(
        map(res => {
          return fetchCommissionGroupsByAffiliateSuccess({ commissionGroup: res });
        }),
        catchError(error => {
          return of(fetchCommissionGroupsByAffiliateFailure({ error }));
        })
      )
    )
  )
);

  getCampaign$ = createEffect(() =>
    this.actions$.pipe(
      ofType(getCommissionGroup),
      mergeMap(action => 
        this.commissionGroupService.getCommissionGroup(action.id).pipe(
          map(res => {
            return getCommissionGroupSuccess({ commissionGroup: res });
          }),
          catchError(error => {
            return of(getCommissionGroupFailure({ error }));
          })
        )
      )
    )
  );

  deleteCommissionGroup$ = createEffect(() =>
    this.actions$.pipe(
      ofType(deleteCommissionGroup),
      mergeMap(action =>
        this.commissionGroupService.removeCommissionGroup(action.id).pipe(
          map(() => {
            return deleteCommissionGroupSuccess({ id: action.id });
          }),
          catchError(error => {
            return of(deleteCommissionGroupFailure({ error }));
          })
        )
      )
    )
  );

  addCommissionGroup$ = createEffect(() =>
    this.actions$.pipe(
      ofType(addCommissionGroup),
      mergeMap(action =>
        this.commissionGroupService.insertCommissionGroup(action.commissionGroup).pipe(
          map(commissionGroup => {
            return addCommissionGroupSuccess({ commissionGroup });
          }),
          catchError(error => {
            return of(addCommissionGroupFailure({ error }));
          })
        )
      )
    )
  );

  updateCommissionGroup$ = createEffect(() =>
    this.actions$.pipe(
      ofType(updateCommissionGroup),
      mergeMap(action =>
        this.commissionGroupService.renewCommissionGroup(action.commissionGroup).pipe(
          map(commissionGroup => {
            return updateCommissionGroupSuccess({ commissionGroup });
          }),
          catchError(error => {
            return of(updateCommissionGroupFailure({ error }));
          })
        )
      )
    )
  );

  constructor(
    private actions$: Actions,
    private commissionGroupService: CommissionGroupService,
    private router: Router
  ) {}
}
